import { Link } from "react-router-dom";
import trainerOne from "../../assets/images/trainer-1.jpg";
import trainerTwo from "../../assets/images/trainer-2.jpg";
import trainerThree from "../../assets/images/trainer-3.jpg";

function TrainersPreview() {
    const trainers = [
        {
            id: 1,
            image: trainerOne,
            name: "Andrei Bontas",
            role: "Instructor fitness",
            description:
                "Experienta, disciplina si atentie la detalii pentru antrenamente corecte si progres constant."
        },
        {
            id: 2,
            image: trainerTwo,
            name: "Cristi Martac",
            role: "Antrenor personal",
            description:
                "Abordare orientata spre rezultate reale, motivatie si transformari obtinute prin munca serioasa."
        },
        {
            id: 3,
            image: trainerThree,
            name: "Echipa Cris Gym",
            role: "Suport si indrumare",
            description:
                "Un mediu in care esti sustinut, ghidat si incurajat sa-ti depasesti limitele la fiecare pas."
        }
    ];

    return (
        <section className="trainers-preview">
            <div className="trainers-preview-container">
                <div className="trainers-preview-header">
                    <p className="trainers-preview-label">Antrenori</p>
                    <h2 className="trainers-preview-title">
                        O echipa care te motiveaza sa evoluezi
                    </h2>
                    <p className="trainers-preview-subtitle">
                        Descopera antrenori dedicati, gata sa te ajute sa lucrezi corect,
                        sa iti cresti disciplina si sa obtii rezultate reale.
                    </p>
                </div>

                <div className="trainers-preview-grid">
                    {trainers.map((trainer) => (
                        <article key={trainer.id} className="trainer-preview-card">
                            <div className="trainer-preview-image-wrapper">
                                <img
                                    src={trainer.image}
                                    alt={trainer.name}
                                    className="trainer-preview-image"
                                />
                            </div>

                            <div className="trainer-preview-content">
                                <span className="trainer-preview-role">{trainer.role}</span>
                                <h3 className="trainer-preview-name">{trainer.name}</h3>
                                <p className="trainer-preview-description">
                                    {trainer.description}
                                </p>

                                <Link to="/antrenori" className="trainer-preview-btn">
                                    Vezi profilul
                                </Link>
                            </div>
                        </article>
                    ))}
                </div>

                <div className="trainers-preview-footer">
                    <Link to="/antrenori" className="trainers-preview-main-btn">
                        Vezi toti antrenorii
                    </Link>
                </div>
            </div>
        </section>
    );
}

export default TrainersPreview;